import { useState, useLayoutEffect } from "react"
import {
  Box,
  MenuItem,
  Grid,
  IconButton,
  keyframes,
  useMediaQuery,
  useTheme,
  Icon,
  Button,
} from "@mui/material"
import { useLocation } from "react-router-dom"
import SmallLogo from "../assets/CharcoalCrazeLogoWhite-NoText.png"
import { MenuTwoTone } from "@mui/icons-material"
import "./navbar.css"
import { useNavigate } from "react-router-dom"
import SideNavBackdrop from "../assets/side-nav-backdrop.svg"
import TopNavBackdrop from "../assets/top-nav-backdrop.svg"
import { motion, AnimatePresence } from "motion/react"
import MenuItemSelectedBackdrop from "../assets/TestamonialsSelector-Solo.svg"
import CancelIcon from '@mui/icons-material/Cancel';

const pages = [
  { title: "Home", linkTo: "/", enabled: true },
  { title: "The Goods", linkTo: "/TheGoods", enabled: true },
  { title: "Food Truck Menu", linkTo: "/FoodTruckMenu", enabled: true},
  { title: "Media & Testimonials", linkTo: "/MediaAndTestimonials", enabled: true },
//  { title: "Todays Menu", linkTo: "/TodaysMenu", enabled: true},
  { title: "Vending Schedule", linkTo: "/VendingSchedule", enabled: true},
//  { title: "How The Smoke Got Rolling", linkTo: "/HowTheSmokeGotRolling", enabled: false},
  { title: "Catering", linkTo: "/Catering", enabled: true},
]


const itemFocusedAnimation = keyframes`
0% { 
    opacity: 1;
    background-position: 70% 70%;
    outline: 1px solid rgba(255,255,255,.3);
}
50% { 
    opacity: 1;
    background-position: 10% 30%;
    outline: 1px solid rgba(255,255,255,1);
}
100% { 
    opacity: 1;
    background-position: 0% 30%;
    outline: 1px solid rgba(255,255,255,.3);
}
`

export function ResponsiveAppBar() {
  const [isSidebarVisible, setIsSidebarVisible] = useState(false)
  const navigate = useNavigate()
  const theme = useTheme();
  const location = useLocation();
  const [prevActiveMenuIndex, setPrevActiveMenuIndex] = useState(0);
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));
  

  const handleMenuSelect = (page: string) => {
    setPrevActiveMenuIndex(getActivePageIndex())
    navigate(page)
    const timer = setTimeout(() => {
    handleCloseNavMenu()
    }, 250);
  }

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    document.body.style.overflow = 'hidden';
    setIsSidebarVisible(true)
  }

  const handleCloseNavMenu = () => {
    document.body.style.overflow = 'unset';
    setIsSidebarVisible(false)
  }

  const handleSidebarFocus = () => {
    document.body.style.overflow = 'hidden';
    setIsSidebarVisible(true)
  }

  const handleSidebarBlur = (event: React.FocusEvent) => {
    // Check if the focus is moving to a child element within the sidebar
    const sidebarElement = event.currentTarget
    const relatedTarget = event.relatedTarget as HTMLElement
    
    if (relatedTarget && sidebarElement.contains(relatedTarget)) {
      // Focus is moving to a child element, keep sidebar visible
      return
    }
    
    // Focus is moving outside the sidebar, hide it
    document.body.style.overflow = 'unset';
    setIsSidebarVisible(false)
  }

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Escape') {
      handleCloseNavMenu()
    }
  }

  // Function to get the active page index for animation
  const getActivePageIndex = () => {
    return pages.findIndex(page => page.linkTo === location.pathname)
  }

  // Calculate the backdrop position based on active page
  const getBackdropPosition = () => {
    const activeIndex = getActivePageIndex()
    if (activeIndex === -1) return 0
    
    // Adjust these values based on your menu item spacing and backdrop size
    const itemHeight = isLargeScreen? 60: 36 // Approximate height of each menu item
    const itemSpacing = 16 // Spacing between items
    const baseOffset = isLargeScreen?20:6 // Base offset from top of menu container
    
    return baseOffset + activeIndex * (itemHeight + itemSpacing)
  }

  const getPrevBackdropPosition = () => {

    if (prevActiveMenuIndex === -1) return 0
    
    // Adjust these values based on your menu item spacing and backdrop size
    const itemHeight = isLargeScreen? 60: 36 // Approximate height of each menu item
    const itemSpacing = 16 // Spacing between items
    const baseOffset = isLargeScreen?20:6 // Base offset from top of menu container
    
    return baseOffset + prevActiveMenuIndex * (itemHeight + itemSpacing)
  }

  return (
    <Grid container flexGrow={1} sx={{ position: 'fixed', zIndex: 9999 }}>
        
      <motion.div 
        style={{
          position: 'fixed', 
          width: '100vw', 
          height: "100vh", 
          
          zIndex: 9998, 
          //transition: 'all .3s ease-in-out', 
          display: isSidebarVisible? 'block': 'none'
        }}
        animate={{backgroundColor: isSidebarVisible?"rgba(0, 0, 0, 0.8)":"rgba(0, 0, 0, 0)", }} 
        onClick={() => handleCloseNavMenu()}
        onKeyDown={handleKeyDown}
      />
      <Button 
        sx={{
          position: 'fixed', 
          width: '50px', 
          height: "50px", 
          top:'10px', right: { xs: '20px', md: 'calc(100vw - 400px)'},
          zIndex: 9999,
          fontSize: '40px',
          cursor: 'pointer', 
          
          visibility: isSidebarVisible? 'visible': 'hidden',
          
        }}
        
        onClick={() => handleCloseNavMenu()}
        onKeyDown={handleKeyDown}
      >
        <CancelIcon fontSize='inherit' sx={{color:'white', transition: 'opacity .5s ease-in-out', 
          opacity: isSidebarVisible? 0.7: 0,
          ":hover":{ transform: 'scale(1.15)', opacity: 1, }}}/>
      </Button>
      <Grid
        sx={{
          flexGrow: 1,zIndex: 9998, 
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        <Grid item justifyContent="center" alignItems="center" position="fixed" top='3vh' left="3vw">
          <IconButton
            size="large"
            aria-label="Open navigation menu"
            aria-controls="menu-appbar"
            aria-haspopup="true"
           
            onClick={handleOpenNavMenu}
            onKeyDown={handleKeyDown}
            sx={{
              transition: "all 0.3s ease-in-out",
              color: "#c0c0c0",
              backgroundColor:'black',
              filter: 'drop-shadow(0px 0px 0px 3px black)',
              border: '1px solid white',
              ":hover": { color: "red", backgroundColor: 'black', borderColor: 'red', scale: '1.1' },
              ":focus": { color: "red", backgroundColor: 'black', borderColor: 'red', scale: '1.1' },
              zIndex: 200,
            }}
          >
            <MenuTwoTone />
          </IconButton>
        </Grid>

        {isLargeScreen &&
        <motion.div 
          style={{  zIndex: 9999, top:'0px', position:'absolute', left: '-200px', display: isSidebarVisible?'flex':'none'}} 
          whileFocus={{x: 200 , y: 0, scaleX: 1 }}
          animate={{ x: isSidebarVisible ? 200   : 0, scaleX: isSidebarVisible ? 1: 0.3, display: isSidebarVisible?'flex':'none' }}
          transition={{ type: "spring", stiffness: 200, damping: 30 }}
        >
          <Box
            id="menu-appbar"
            tabIndex={0}
            onFocus={handleSidebarFocus}
            onBlur={handleSidebarBlur}
            onKeyDown={handleKeyDown}
            sx={{
              zIndex: 9999,
              textAlign: "center",
              padding:'0px',
              margin:'0px',
              position: 'absolute', 
              top:  '-10px',
              left: '-5px',
              width:  '600px',
              height:   '100vh',
              paddingTop:'60px',
              bgcolor: "transparent",
              maxWidth: '600px',
              backgroundImage:  `url(${SideNavBackdrop})`,
              backgroundSize: "cover",
              backgroundPosition: {xs: "center", md:"right"},
              boxShadow: 'none',
              outline: 'none', // Remove default focus outline
            }}
          >
            {/* Animated Backdrop for Active Menu Item */}
            <AnimatePresence mode="sync">
              {getActivePageIndex() !== -1 && (
                <motion.div
                  key={location.pathname}
                  initial={{ 
                    y: getBackdropPosition(), 
                    x: -200,
                    scaleX: 3.1,
                    scaleY: 1.8,
                    rotate: 0
                  }}
                  animate={{ 
                    y: getBackdropPosition(), 
                    x: isSidebarVisible? 300: 0,
                    scaleX: 3.1,
                    scaleY: 1.8,
                    rotate: 1
                  }}
                  exit={{ 
                    y: getBackdropPosition(), 
                    x: -200,
                    scaleX: 3.1,
                    scaleY: 1.8,
                    rotate: 0
                  }}
                  transition={{ 
                    type: "spring", 
                    stiffness: 300, 
                    damping: 30,
                    duration: 0.5
                  }}
                  style={{
                    position: 'absolute',
                    left: '0px',
                    zIndex: 1,
                    pointerEvents: 'none',
                    transformOrigin: 'right',
                  }}
                  tabIndex={-1}
                >
                  <img
                    src={MenuItemSelectedBackdrop}
                    alt="Active menu backdrop"
                    style={{
                      width: '100%',
                      height: '60px',
                      maxHeight: '60px',
                      objectFit: 'cover',
                      filter: 'drop-shadow(0 4px 6px rgba(0,0,0,0.9))',
                    }}
                    tabIndex={-1}
                  />
                </motion.div>
              )}
            </AnimatePresence>
            
            <Grid container justifyContent="flex-start" flexDirection="column" sx={{ position: 'relative', zIndex: 2,  }}>
              {pages.map((page, index) => (
                <motion.div
                  aria-label={`Link to ${page.title} page.`}
                  style={{marginTop: '8px', marginBottom: '10px', width:'400px'}}
                  onTap={ ()=>{
                    handleMenuSelect(page.linkTo)
                  }}
                  //onFocus={() => handleSidebarFocus()}
                  key={page.title}
                  initial={{ scale: 0.9 }}
                  animate={{ 
                    scale: page.linkTo === location.pathname ? 1 : 0.9,
                    x: 0,
                    scaleX: isSidebarVisible ? 1: 0.5 
                  }}
                  whileHover={{ 
                    scale: page.linkTo === location.pathname ? 1 : 1.1,
                    x: page.linkTo === location.pathname ? 0 : 30,
                    color: 'rgb(255,255,255)',
                    backgroundColor: page.linkTo === location.pathname ?  "none" : "rgba(0,0,0,.4)" 
                  }}
                  transition={{ 
                    // delay: index * 0.1,
                    duration: 0.3,
                    type: "spring",
                    stiffness: 300
                  }}
                  tabIndex={-1}
                >
                  <MenuItem
                    onClick={() => {
                      handleMenuSelect(page.linkTo)
                    }}
                    href={page.linkTo}
                    sx={{
                      cursor: page.linkTo === location.pathname ?"default": "pointer",
                      pointerEvents: page.linkTo === location.pathname ?"none": "auto",
                      fontSize: "22px",
                      paddingLeft: "40px",
                      paddingRight: "auto",
                      paddingTop: "13px",
                      paddingBottom: "13px",
                      whiteSpace: "nowrap",
                      textAlign: "left",
                      position: "relative",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      width: "100%",
                      zIndex: 3,
                      fontWeight: page.linkTo === location.pathname ? "bold" : "normal",
                      outline: 'none', // Remove default focus outline
                      "&:focus": {
                        animation: page.linkTo === location.pathname ? "none" : `${itemFocusedAnimation} 2s ease-in-out infinite`,
                        outline: 'none',
                      },
                      "&.Mui-disabled": {
                        color: page.linkTo === location.pathname ? "rgb(0,0,0)" : "rgb(255,255,255)",
                        cursor: "default",
                        fontWeight: page.linkTo === location.pathname ? "bold" : "bold",
                        animation: "none!important",
                      },
                    }}
                    tabIndex={0}
                  >
                    <motion.div 
                      style={{ 
                        position: 'relative',
                        zIndex: 3,
                        color: page.linkTo === location.pathname ? "rgb(0,0,0)" : "rgb(255,255,255)",
                        width: "100%",
                        textAlign: "left",
                        display: "flex",
                        justifyContent: "flex-start",
                      }}
                      animate={{
                        scale: page.linkTo === location.pathname ? 1 : 0.9,
                      }}
                      whileTap={{
                        scale: page.linkTo === location.pathname ? 1 : .8,
                      }}
                      transition={{ 
                        type: "spring", 
                        stiffness: 400, 
                        damping: 25 
                      }}
                      tabIndex={-1}
                    >
                      {page.title}
                    </motion.div>
                  </MenuItem>
                </motion.div>
              ))}
              <motion.div 
                style={{
                  left: '120px', top: '450px', position: 'absolute',
                  cursor:
                    window.location.pathname === pages[0].linkTo
                      ? "default"
                      : "pointer",
                  pointerEvents:
                    window.location.pathname === pages[0].linkTo
                      ? "none"
                      : "auto",
                  filter: window.location.pathname === pages[0].linkTo? 'drop-shadow(0px 10px 5px rgba(0,0,0, 0.7))': 'none'
                }}
                initial={{ scale: 0.9 }}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.8 }}
              >
                  <img
                    alt="Charcoal Craze logo links to home "
                    src={SmallLogo}
                    style={{
                      height: "120px",
                      width: "auto",
                      maxWidth: "300px",
                      alignItems: "center",
                      verticalAlign: "middle",
                      cursor:
                        window.location.pathname === pages[0].linkTo
                          ? "default"
                          : "pointer",
                      pointerEvents:
                        window.location.pathname === pages[0].linkTo
                          ? "none"
                          : "auto",
                    }}
                    onClick={() => {
                      navigate(pages[0].linkTo)
                    }}
                  />
              </motion.div>
            </Grid>
          </Box>
        </motion.div>
        
        }
        {!isLargeScreen &&
        <motion.div 
          style={{  position: 'absolute', display: isSidebarVisible?'flex':'none'}} 
          whileFocus={{ x: 0, y: isSidebarVisible?380: -400, scaleY: 1 }}
          animate={{ y: isSidebarVisible ? 0: -300, scaleY: isSidebarVisible ? 1 : 0.3, display: isSidebarVisible?'flex':'none' }}
          transition={{ type: "spring", stiffness: 200, damping: 30 }}
        >
          <Box
            id="menu-appbar"
            tabIndex={0}
            onFocus={handleSidebarFocus}
            onBlur={handleSidebarBlur}
            onKeyDown={handleKeyDown}
            sx={{
              textAlign: "center",
              padding:'0px',
              margin:'0px',
              position: 'absolute',
              
              width: '100vw',
              height: '550px',
              paddingTop:'55px',
              bgcolor: "transparent",
              backgroundImage: `url(${TopNavBackdrop})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              boxShadow: 'none',
              outline: 'none', // Remove default focus outline
              minHeight: '400px'
            }}
          >
            {/* Animated Backdrop for Active Menu Item */}
            <AnimatePresence mode="sync">
              {getActivePageIndex() !== -1 && (
                <motion.div
                  key={location.pathname}
                  initial={{ 
                    y: getPrevBackdropPosition(), 
                    x: '65vw',
                    scaleX: 3,
                    scaleY: 1.6,
                    rotate: 0
                  }}
                  animate={{ 
                    y: getBackdropPosition(), 
                    x: '65vw',
                    scaleX: 3,
                    scaleY: 1.6,
                    rotate: 1
                  }}
                  transition={{ 
                    type: "spring", 
                    stiffness: 300, 
                    damping: 30,
                    duration: 0.4
                  }}
                  style={{
                    position: 'absolute',
                    left: '0',
                    zIndex: 1,
                    pointerEvents: 'none',
                    transformOrigin: 'right',
                  }}
                >
                  <img
                    src={MenuItemSelectedBackdrop}
                    alt="Active menu backdrop"
                    style={{
                      width: '100%',
                      height: '60px',
                      maxHeight: '60px',
                      objectFit: 'cover',
                      filter: 'drop-shadow(0 4px 6px rgba(0,0,0,0.9))',
                    }}
                  />
                </motion.div>
              )}
            </AnimatePresence>
            
            <Grid container justifyContent="center" flexDirection="column" sx={{ position: 'relative', zIndex: 2,  }}>
              {pages.map((page, index) => (
                <motion.div
                  aria-label={`Link to ${page.title} page.`}
                  onClick={() => {
                      handleMenuSelect(page.linkTo)
                    }}
                  onTap={() => {
                      handleMenuSelect(page.linkTo)
                    }}
                  onFocus={() => setIsSidebarVisible(true)}
                  key={page.title}
                  initial={{  scale: page.linkTo === location.pathname ? 0.9 :0.8, }}
                  animate={{  x: 0 }}
                  whileHover={{ 
                    scale: page.linkTo === location.pathname ? 0.9 : 1,
                    color: 'rgb(255,255,255)',
                    backgroundColor: page.linkTo === location.pathname ?  "none" : "rgba(0,0,0,.4)" 
                  }}
                  transition={{ 
                    // delay: index * 0.1,
                    duration: 0.3,
                    type: "spring",
                    stiffness: 300
                  }}
                  tabIndex={-1}
                >
                  <MenuItem
                    onClick={() => {
                      handleMenuSelect(page.linkTo)
                    }}
                    sx={{
                      cursor: page.linkTo === location.pathname ?"default": "pointer",
                      pointerEvents: page.linkTo === location.pathname ?"none": "auto",
                      fontSize: "20px",
                      padding: "auto",
                      marginRight: "auto",
                      marginLeft:'auto',
                      paddingTop: "11px",
                      paddingBottom: "11px",
                      whiteSpace: "nowrap",
                      textAlign: "center",
                      position: "relative",
                      width: '100vw',
                      zIndex: 3,
                      fontWeight: page.linkTo === location.pathname ? "bold" : "normal",
                      outline: 'none', // Remove default focus outline
                      "&:focus": {
                        animation: page.linkTo === location.pathname ? "none" : `${itemFocusedAnimation} 2s ease-in-out infinite`,
                        outline: 'none',
                      },
                      "&.Mui-disabled": {
                        color: page.linkTo === location.pathname ? "rgb(0,0,0)" : "rgb(255,255,255)",
                        cursor: "default",
                        fontWeight: page.linkTo === location.pathname ? "bold" : "bold",
                        animation: "none!important",
                      },
                    }}
                    tabIndex={0}
                  >
                    <motion.div 
                      style={{ 
                        position: 'relative',
                        padding: 'auto',
                        margin:'auto',
                        zIndex: 3,
                        color: page.linkTo === location.pathname ? "rgb(0,0,0)" : "rgb(255,255,255)",
                        scale: page.linkTo === location.pathname ? 1 : 0.9,
                      }}
                      whileTap={{
                        scale: page.linkTo === location.pathname ? 1 : .8,
                      }}
                      transition={{ 
                        type: "spring", 
                        stiffness: 400, 
                        damping: 25 
                      }}
                      tabIndex={-1}
                    >
                      {page.title}
                    </motion.div>
                    
                  </MenuItem>
                </motion.div>
              ))}
              <IconButton />
            </Grid>
          </Box>
        </motion.div>
        }
      </Grid>
    </Grid>
  )
}
